import {
    defaultMenuItems,
    conditionalMenuItems
} from "@/models/menuItems.js";

export default {
    computed: {
        // Novi computed property koji zamenjuje mutiran items
        computedItems() {
            let items = [...defaultMenuItems];
            if (!this.user) return items;
            // Admin-specific items
            if (this.user?.type === "admin") {
                // Dodaj post_report na poziciju 3
                const hasPostReport = items.some((item) => item.title === "post_report");
                if (!hasPostReport) {
                    items.splice(3, 0, conditionalMenuItems.post_report);
                }

                // Dodaj users_guest na poziciju 17 (ili na kraj ako je kraći)
                const hasUsersGuest = items.some((item) => item.title === "users_guest");
                if (!hasUsersGuest) {
                    const insertIndex = Math.min(17, items.length);
                    items.splice(insertIndex, 0, conditionalMenuItems.users_guest);
                }
            }
            // Restaurant/guest report logika
            if (this.user?.type === "restaurant") {
                if (!this.user?.user_menu?.menu1) {
                    const hasSuppliersLink = items.some((item) => item.title === "suppliers");
                    if (!hasSuppliersLink) {
                        items.splice(3, 0, conditionalMenuItems.suppliers);
                    }
                    const hasGuestReport = items.some((item) => item.title === "guest_report");
                    if (!hasGuestReport) {
                        items.splice(3, 0, conditionalMenuItems.guest_report);
                    }

                    // Additional meals for restaurants with komplet_obroci
                    if (this.restaurant?.settings?.komplet_obroci) {
                        const hasAdditionalMeals = items.some((item) => item.title === "additional_meals");
                        if (!hasAdditionalMeals) {
                            items.splice(2, 0, conditionalMenuItems.additional_meals);
                        }
                    }

                    items = items.filter((item) => !['company-menu', 'company-report'].includes(item.to.name));
                }
            }
            else if (this.user?.type === "report_guest") {
                const hasGuestReportNew = items.some((item) => item.title === "guest_report");
                if (!hasGuestReportNew) {
                    items.splice(3, 0, conditionalMenuItems.guest_report);
                }
            }
            else {
                if (this.site?.settings?.lice_bez_ugovora || this.user?.type === "admin") {
                    const hasGuestReport = items.some((item) => {
                        return item.title === "guest_report";
                    });
                    if (!hasGuestReport) {
                        items.splice(3, 0, conditionalMenuItems.guest_report);
                    }
                } else {
                    // Ukloni guest_report ako postoji
                    items = items.filter((item) => item.title !== "guest_report");
                }

            }
            // Customers restaurant logika
            const customersRestaurantIndex = items.findIndex(
                (item) => item.title === "Корисници изабраног ресторана"
            );

            if (customersRestaurantIndex > -1) {
                // Ažuriraj postojeću stavku
                items[customersRestaurantIndex] = {
                    ...items[customersRestaurantIndex],
                    to: {
                        ...items[customersRestaurantIndex].to,
                        params: {
                            id: this.user?.restaurants?.[0]?.id || "",
                        },
                    },
                };
            }
            else {
                // Dodaj novu stavku ako ne postoji customers_restoran
                const hasCustomersRestoran = items.some(
                    (item) => item.title === "customers_restoran"
                );
                if (
                    !hasCustomersRestoran &&
                    this.user &&
                    !this.user.user_menu &&
                    this.user.restaurants?.[0]
                ) {
                    const customerRestaurantItem = {
                        ...conditionalMenuItems.customers_restaurant,
                        to: {
                            ...conditionalMenuItems.customers_restaurant.to,
                            params: {
                                id: this.user.restaurants[0].id || 0,
                            },
                        },
                    };
                    items.push(customerRestaurantItem);
                }

                // Ažuriraj params za customers_restoran
                items = items.map((item) => {
                    if (item.title === "customers_restoran") {
                        return {
                            ...item,
                            to: {
                                ...item.to,
                                params: {
                                    id: this.user?.restaurants?.[0]?.id || "",
                                },
                            },
                        };
                    }
                    return item;
                });
            }

            // Entity type logika (meals vs products)
            items = items.map((item) => {
                if (item.to?.name === "jela") {
                    return {
                        ...item,
                        title: this.site?.entity_type === "shop" ? "products" : "meals_main",
                    };
                }
                return item;
            });

            // Settings logika
            if (
                (this.user?.type == "restaurant" && this.restaurant?.pivot?.settings == 1) ||
                this.user?.type == "admin"
            ) {
                const hasSettings = items.some(
                    (item) =>
                        item.title == "Подешавања" ||
                        item.title == "Podesavanja" ||
                        item.title == "settings"
                );
                if (!hasSettings) {
                    items.splice(10, 0, conditionalMenuItems.settings);
                }
            }

            // Admin specifične stavke - messages i delivery_post
            if (this.user?.type == "admin") {
                const hasMessages = items.some((item) => item.title == "messages");
                const hasPosts = items.some((item) => item.title == "delivery_post");

                if (!hasMessages) {
                    items.splice(15, 0, conditionalMenuItems.messages);
                }
                if (!hasPosts) {
                    items.splice(14, 0, conditionalMenuItems.delivery_post);
                }
            }

            if (this.user.type === "customer" && this.$store.state.company?.contract === 4) {
                items.splice(1, 0, conditionalMenuItems.customerSelfReport);
            }
            if (this.user.type === "company" && this.$store.state.company?.contract === 4) {

                items.splice(1, 0, conditionalMenuItems.companyRestaurants);
            }
            // Uklanjanje duplikata po item.to.name
            items = items.filter((item, index, self) => {
                return index === self.findIndex(i => i.to?.name === item.to?.name);
            });
            return items;
        },
    },
};
